import React, { useState } from 'react';
import Button from '~/components/Button';
import CheckBox from '~/components/CheckBox';
import { StackScreenLayout } from '~/screens/style';
import { t } from '~/utils/i18n';
import {
  ScrollView,
  Image,
  Title,
  Descp,
  CheckRow,
  CheckText,
  Footer,
  SuccessTitle,
} from './style';

type DeleteAccountLayoutProps = {
  deleteSuccess: boolean;
  loading: boolean;
  initialChecked?: boolean;
  onBack: () => void;
  onDelete: () => void;
  onBackToStart: () => void;
};

export default function DeleteAccount({
  deleteSuccess,
  loading,
  initialChecked = false,
  onBack,
  onDelete,
  onBackToStart,
}: DeleteAccountLayoutProps): JSX.Element {
  const [checked, setChecked] = useState(initialChecked);
  if (deleteSuccess) {
    return (
      <StackScreenLayout bgColorKey="c2">
        <ScrollView style={{ paddingTop: 48 }}>
          <Image source={require('~/assets/imgs/gif/delete_user_2.gif')} />
          <SuccessTitle>{t('deleteUserSuccess.title')}</SuccessTitle>
          <Descp>{t('deleteUserSuccess.descp')}</Descp>
        </ScrollView>
        <Footer>
          <Button
            testID={'buttonBackToStart'}
            type={'secondary-base'}
            text={t('deleteUserSuccess.backToStart')}
            flex
            onPress={() => onBackToStart()}
          />
        </Footer>
      </StackScreenLayout>
    );
  }
  return (
    <StackScreenLayout
      backButtonTestID={'buttonBack'}
      title={t('screens.deleteAccount')}
      onBackPress={onBack}
    >
      <ScrollView>
        <Image source={require('~/assets/imgs/gif/delete_user_1.gif')} />
        <Title>{t('deleteUser.title')}</Title>
        <Descp>{t('deleteUser.descp')}</Descp>
        <CheckRow>
          <CheckBox
            testID={'checkBox'}
            checked={checked}
            onChange={setChecked}
          />
          <CheckText>{t('deleteUser.checkText')}</CheckText>
        </CheckRow>
      </ScrollView>
      <Footer>
        <Button
          testID={'buttonDelete'}
          state={checked ? 'default' : 'disabled'}
          type={'destructive'}
          text={t('deleteUser.deleteButton')}
          flex
          loading={loading}
          onPress={() => onDelete()}
        />
      </Footer>
    </StackScreenLayout>
  );
}
